
import CommonMixin from '@/mixins/CommonMixin';

export default {
  mixins: [CommonMixin]
};
